import { LogzioTheme, SidenavSubjects } from '@logz-pkg/enums';
import { ButtonGroup, Group, NotificationService } from '@logz-ui/styleguide';
import { FunctionComponent } from 'react';
import { ErrorHandlingService } from 'services/error-handling.service';
import { themeService } from 'ui/components/App/theme.service';
import { useSessionState } from 'ui/state/hooks';

const logzThemeToLabel = {
  [LogzioTheme.Light]: 'Light',
  [LogzioTheme.Dark]: 'Dark',
};

const themeOptions = [
  { value: LogzioTheme.Light, label: logzThemeToLabel[LogzioTheme.Light] },
  { value: LogzioTheme.Dark, label: logzThemeToLabel[LogzioTheme.Dark] },
];

export const ThemePicker: FunctionComponent = () => {
  const { userSettings } = useSessionState();

  const handleThemeChange = async (newThemeValue: LogzioTheme) => {
    try {
      await themeService.setTheme(newThemeValue);

      NotificationService.success({
        message: 'Updated the Logz.io Theme',
      });
    } catch (error) {
      ErrorHandlingService.handleApiError({
        title: 'Failed to update Logz.io Theme',
        error,
      });
    }
  };

  return (
    <Group pl={5} pb={2}>
      <ButtonGroup
        options={themeOptions}
        value={userSettings?.logzioTheme}
        onChange={handleThemeChange}
        subject={SidenavSubjects.ThemeSelector}
      />
    </Group>
  );
};
